'use strict';

var processInclude = require('./util');

$(document).ready(function () {
    processInclude(require('./searchOrder/searchOrder'));
    processInclude(require('./components/returnOpenSide'));

    if ($('#js-orderN-thankyou').val() !== 'null') {
        var orderN = $('#js-orderN-thankyou').val();
        $('#order-id-value').val(orderN);
    }
});
